module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.consulta && _vm.ultimaRevisao) ? _c('div', [_c('ed-form', [_c('div', {
    staticClass: "row text-left"
  }, [_c('ed-alert', {
    staticClass: "col-12 mb-3",
    attrs: {
      "type": "error"
    }
  }, [_vm._v("\n\t\t\t\t\tEssa consulta está com o PCMSO desatualizado. Para continuar você deve selecionar o último PCMSO válido dessa Frente de Trabalho.\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#c1d19c"
    }
  }, [_c('b', [_vm._v("Último PCMSO válido: ")]), _vm._v(" "), (_vm.ultimaRevisao.parent) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.ultimaRevisao.parent.rev) + " (" + _vm._s(_vm.ultimaRevisao.parent.descricao) + " em " + _vm._s(_vm.$utilidade.toDate(_vm.ultimaRevisao.parent.data_hora, true)) + ") /\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.ultimaRevisao.rev) + " (" + _vm._s(_vm.ultimaRevisao.descricao) + " em " + _vm._s(_vm.$utilidade.toDate(_vm.ultimaRevisao.data_hora, true)) + ")\n\t\t\t\t\t")])]), _vm._v(" "), (_vm.consulta.fdt) ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#eeeeee"
    }
  }, [_c('b', [_vm._v("Frente de Trabalho: ")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.fdt.pcmso) + " (" + _vm._s(_vm.consulta.fdt.descricao) + ")\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.consulta.revisao) ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#eeeeee"
    }
  }, [_c('b', [_vm._v("Revisão: ")]), _vm._v(" "), (_vm.consulta.revisao.parent) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.revisao.parent.rev) + " (" + _vm._s(_vm.consulta.revisao.parent.descricao) + " em " + _vm._s(_vm.$utilidade.toDate(_vm.consulta.revisao.parent.data_hora, true)) + ") /\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.revisao.rev) + " (" + _vm._s(_vm.consulta.revisao.descricao) + " em " + _vm._s(_vm.$utilidade.toDate(_vm.consulta.revisao.data_hora, true)) + ")\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.consulta.ghe) ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#eeeeee"
    }
  }, [_c('b', [_vm._v("GHE (Setor): ")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.ghe.ghe) + " (" + _vm._s(_vm.consulta.ghe.descricao) + ")\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.consulta.funcao) ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#eeeeee"
    }
  }, [_c('b', [_vm._v("Função: ")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.funcao.nome) + "\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-3"
  }, [_c('h4', [_vm._v("Selecione o novo PCMSO")])]), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6",
    attrs: {
      "label": "Frente de Trabalho",
      "items": _vm.list.fdt,
      "loading": _vm.loadingFdt,
      "itemText": "fdt",
      "required": ""
    },
    on: {
      "input": _vm.getGhe
    },
    model: {
      value: (_vm.consultaNova.id_fdt),
      callback: function($$v) {
        _vm.$set(_vm.consultaNova, "id_fdt", $$v)
      },
      expression: "consultaNova.id_fdt"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6",
    attrs: {
      "label": "GHE (Setor)",
      "items": _vm.list.ghe,
      "loading": _vm.loadingGhe,
      "itemText": "ghe",
      "item-group": "",
      "required": "",
      "disabled": !_vm.consultaNova.id_fdt
    },
    on: {
      "input": _vm.getFuncao
    },
    model: {
      value: (_vm.consultaNova.id_ghe),
      callback: function($$v) {
        _vm.$set(_vm.consultaNova, "id_ghe", $$v)
      },
      expression: "consultaNova.id_ghe"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Função",
      "items": _vm.list.funcao,
      "loading": _vm.loadingFuncao,
      "itemText": "nome",
      "required": "",
      "disabled": !_vm.consultaNova.id_ghe
    },
    on: {
      "input": _vm.getCredenciada
    },
    model: {
      value: (_vm.consultaNova.id_funcao),
      callback: function($$v) {
        _vm.$set(_vm.consultaNova, "id_funcao", $$v)
      },
      expression: "consultaNova.id_funcao"
    }
  }), _vm._v(" "), (_vm.tabela_preco !== null) ? _c('ed-alert', {
    staticClass: "col-12 mt-3",
    attrs: {
      "type": "error"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.tabela_preco) + "\n\t\t\t\t")]) : _vm._e()], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f5aafbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/consulta-externa/_include/consulta-alterar-revisao.vue
// module id = 1567
// module chunks = 45